module.exports = __webpack_public_path__ + "img/article1.d7e68532.jpg";